import { render } from "./MascotPanel.vue?vue&type=template&id=8472950a&scoped=true"
import script from "./MascotPanel.vue?vue&type=script&lang=js"
export * from "./MascotPanel.vue?vue&type=script&lang=js"

import "./MascotPanel.vue?vue&type=style&index=0&id=8472950a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8472950a"]])

export default __exports__